export default {
      id: "user-usage",
      viewBox: "0 0 48 48",
      url: "assets/" + "sprite.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }